var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUp = function SvgUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M12.119 3.088A2.25 2.25 0 0 0 9.338 4.63l-.179.625A2.74 2.74 0 0 1 8.55 6.35L6.947 8.113a.75.75 0 0 0 1.11 1.009l1.602-1.763c.441-.484.763-1.062.941-1.69l.178-.625a.75.75 0 1 1 1.444.413l-.178.624a5.7 5.7 0 0 1-.832 1.735A.75.75 0 0 0 11.826 9H16a.501.501 0 0 1 .175.969.752.752 0 0 0-.3 1.2.5.5 0 0 1-.281.822.75.75 0 0 0-.563.472.76.76 0 0 0 .113.728.5.5 0 0 1-.213.775.75.75 0 0 0-.45.9q.02.062.019.134c0 .275-.225.5-.5.5h-3.047c-.394 0-.781-.116-1.11-.334L7.917 13.88a.75.75 0 0 0-1.041.21.75.75 0 0 0 .21 1.04l1.927 1.285a3.5 3.5 0 0 0 1.941.587H14a2 2 0 0 0 2-1.937 2 2 0 0 0 .71-1.97 2 2 0 0 0 .703-2.177c.362-.366.587-.866.587-1.419a2 2 0 0 0-2-2h-2.884a7 7 0 0 0 .368-1.006l.178-.625a2.25 2.25 0 0 0-1.543-2.781M3 8c-.553 0-1 .447-1 1v7c0 .553.447 1 1 1h2c.553 0 1-.447 1-1V9c0-.553-.447-1-1-1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUp);
export default ForwardRef;